module.exports = __webpack_public_path__ + "static/low-back-9d1eb9ea1cb0b4946d64635fba533c70.jpg";